import { trackEvent } from '../lib/tracking';

const passos = [
  { num: '01', titulo: 'Planta e medidas', descricao: 'Recebemos planta, medidas ou o projeto do arquiteto.' },
  { num: '02', titulo: 'Necessidades de cada ambiente', descricao: 'Mapeamos privacidade, circulação e uso de cada sala.' },
  { num: '03', titulo: 'Especificação da solução', descricao: 'Definimos o sistema adequado para cada espaço.' },
  { num: '04', titulo: 'Proposta', descricao: 'Estruturamos a proposta comercial e o escopo do projeto.' },
  { num: '05', titulo: 'Instalação', descricao: 'Coordenamos a implantação de forma organizada.' },
  { num: '06', titulo: 'Pós-venda', descricao: 'Acompanhamos o resultado após a entrega.' },
];

export default function ProjetoCompleto() {
  return (
    <section className="bg-white">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <div>
            <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
              Projeto completo
            </p>
            <h2 className="text-foreground-950 text-[28px] md:text-[38px] font-semibold tracking-tight leading-tight mb-6">
              Não vendemos apenas metros de divisória.
            </h2>
            <p className="text-foreground-500 text-[15px] md:text-[16px] leading-relaxed max-w-lg mb-9">
              Analisamos planta, circulação, privacidade, estética, mobiliário, infraestrutura e
              necessidade de cada ambiente para definir a solução adequada.
            </p>

            <a
              href="#analise"
              onClick={() => trackEvent('form_start', { source: 'projeto_completo' })}
              className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-[15px] px-7 py-4 rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              Solicitar análise
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-9">
            {passos.map((p) => (
              <div key={p.num} className="border-t border-background-200 pt-5">
                <span className="text-primary-500 text-[13px] font-bold tracking-wider">
                  {p.num}
                </span>
                <h3 className="text-foreground-950 font-semibold text-[15px] mt-1.5 mb-1.5">
                  {p.titulo}
                </h3>
                <p className="text-foreground-500 text-[13px] leading-relaxed font-light">
                  {p.descricao}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}